import { HeadCellType } from '@fabric-ui/components/Table';
import { z } from 'zod/v4';
import { SortDir } from '../CustomDashboards/types';
import { defaultExternalProjectionHeadCells } from './basic-logs-provider.utils';
import { LOGS_CONST } from './Logs.const';
import { newDefaultDateRange } from './Logs.utils';
import { QueryType } from './types';

export const mapHeadCells = (headCells: HeadCellType[]) => headCells.map(({ id }) => id);

const sort = z.object({ id: z.string(), dir: z.enum(SortDir) });

export const logsSearchSchema = z.object({
  tabId: z.string().optional().default('-1'),
  query: z.string().optional().default(''),
  title: z.string().optional().default(''),
  lastSearch: z.coerce.date().optional(),
  queryType: z.enum(QueryType).optional().default(QueryType.Basic),
  categoryId: z.string().optional().nullable(),
  description: z.string().optional(),
  page: z.number().optional().default(0),
  sort: sort.optional(),
  date: z.tuple([z.coerce.date(), z.coerce.date()]).optional().default([newDefaultDateRange[0], newDefaultDateRange[1]]),
  table: z.string().optional().default(LOGS_CONST.EXTERNAL_PROJECTION_TABLE),
  headCells: z.string().array().optional().default(mapHeadCells(defaultExternalProjectionHeadCells)),
  autoSearch: z.coerce.boolean().optional().default(false),
});
